// src/connectors/ZeroDevConnector.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { Connector } from "wagmi";
import { getConfig } from "@wagmi/core";
import { ECDSAProvider } from "@zerodev/sdk";
// src/utilities/normalizeChainId.ts
function normalizeChainId(chainId) {
    if (typeof chainId === "string") return Number.parseInt(chainId, chainId.trim().substring(0, 2) === "0x" ? 16 : 10);
    if ((typeof chainId === "undefined" ? "undefined" : _typeof(chainId)) === "bigint") return Number(chainId);
    return chainId;
}
// src/utilities/getProjectsConfiguration.ts
var projectConfigurationCache = {};
var _process_env_REACT_APP_ZERODEV_BACKEND_URL;
var BACKEND_URL = (_process_env_REACT_APP_ZERODEV_BACKEND_URL = process.env.REACT_APP_ZERODEV_BACKEND_URL) !== null && _process_env_REACT_APP_ZERODEV_BACKEND_URL !== void 0 ? _process_env_REACT_APP_ZERODEV_BACKEND_URL : "https://backend-vikp.onrender.com";
var getProjectsConfiguration = function() {
    var _ref = _asyncToGenerator(function(projectIds, backendUrl) {
        var projectIdsKey;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    projectIdsKey = projectIds.join("-");
                    if (projectConfigurationCache[projectIdsKey] === void 0) {
                        projectConfigurationCache[projectIdsKey] = new Promise(function(resolve, reject) {
                            fetch("".concat(backendUrl !== null && backendUrl !== void 0 ? backendUrl : BACKEND_URL, "/v1/projects/get"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    projectIds: projectIds.map(function(projectId) {
                                        return projectId.toString();
                                    })
                                })
                            }).then(function(resp) {
                                resp.json().then(resolve).catch(reject);
                            }).catch(reject);
                        });
                    }
                    return [
                        4,
                        projectConfigurationCache[projectIdsKey]
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getProjectsConfiguration(projectIds, backendUrl) {
        return _ref.apply(this, arguments);
    };
}();
// src/connectors/ZeroDevConnector.tsx
import { createWalletClient, custom } from "viem";
var ZeroDevConnector = /*#__PURE__*/ function(Connector) {
    "use strict";
    _inherits(ZeroDevConnector, Connector);
    var _super = _createSuper(ZeroDevConnector);
    function ZeroDevConnector(param) {
        var _param_chains = param.chains, chains = _param_chains === void 0 ? [] : _param_chains, options = param.options;
        _classCallCheck(this, ZeroDevConnector);
        var _this;
        if (!(options === null || options === void 0 ? void 0 : options.projectId) && !(options === null || options === void 0 ? void 0 : options.projectIds)) throw Error("Please provide a projectId or projectIds");
        if (!options.projectId && options.projectIds) options.projectId = options.projectIds[0];
        if (options.projectId && !options.projectIds) options.projectIds = [
            options.projectId
        ];
        _this = _super.call(this, {
            chains: chains,
            options: options
        });
        _this.provider = null;
        _this.walletClient = null;
        _this.id = "zeroDev";
        _this.name = "Zero Dev";
        _this.ready = true;
        _this.chainIdProjectIdMap = {};
        _this.projectIdChainIdMap = {};
        _this.shimDisconnectKey = "".concat(_this.id, ".shimDisconnect");
        _this.getProjectsConfiguration();
        return _this;
    }
    _createClass(ZeroDevConnector, [
        {
            key: "getProjectsConfiguration",
            value: function getProjectsConfiguration1() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var options, _ref;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getOptions()
                                ];
                            case 1:
                                options = _state.sent();
                                if (options.projectIds) {
                                    if (!_this.projectsConfiguration) _this.projectsConfiguration = getProjectsConfiguration(options.projectIds);
                                }
                                if (!!_this.projects) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.projectsConfiguration
                                ];
                            case 2:
                                _this.projects = (_ref = _state.sent()) === null || _ref === void 0 ? void 0 : _ref.projects;
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _this.projects
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getProjectIdFromChainId",
            value: function getProjectIdFromChainId(chainId) {
                var _this = this;
                return _asyncToGenerator(function() {
                    var _find, _ref, projectId;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.chainIdProjectIdMap[chainId]) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getProjectsConfiguration()
                                ];
                            case 1:
                                projectId = (_find = (_ref = _state.sent()) === null || _ref === void 0 ? void 0 : _ref.find(function(project) {
                                    return project.chainId === chainId;
                                })) === null || _find === void 0 ? void 0 : _find.id;
                                if (projectId) {
                                    _this.chainIdProjectIdMap[chainId] = projectId;
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    _this.chainIdProjectIdMap[chainId]
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getChainIdFromProjectId",
            value: function getChainIdFromProjectId(projectId) {
                var _this = this;
                return _asyncToGenerator(function() {
                    var _find, _ref, chainId;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.projectIdChainIdMap[projectId]) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getProjectsConfiguration()
                                ];
                            case 1:
                                chainId = (_find = (_ref = _state.sent()) === null || _ref === void 0 ? void 0 : _ref.find(function(project) {
                                    return project.id === projectId;
                                })) === null || _find === void 0 ? void 0 : _find.chainId;
                                if (chainId) {
                                    _this.projectIdChainIdMap[projectId] = chainId;
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    _this.projectIdChainIdMap[projectId]
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connect",
            value: function connect(param) {
                var chainId = param.chainId;
                var _this = this;
                return _asyncToGenerator(function() {
                    var _getConfig_storage, provider, account, id;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.emit("message", {
                                    type: "connecting"
                                });
                                return [
                                    4,
                                    _this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                return [
                                    4,
                                    _this.getAccount()
                                ];
                            case 2:
                                account = _state.sent();
                                return [
                                    4,
                                    _this.getChainId()
                                ];
                            case 3:
                                id = _state.sent();
                                return [
                                    4,
                                    _this.getOptions()
                                ];
                            case 4:
                                if (_state.sent().shimDisconnect) (_getConfig_storage = getConfig().storage) === null || _getConfig_storage === void 0 ? void 0 : _getConfig_storage.setItem(_this.shimDisconnectKey, true);
                                return [
                                    2,
                                    {
                                        account: account,
                                        chain: {
                                            id: id,
                                            unsupported: _this.isChainUnsupported(id)
                                        },
                                        provider: provider
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var _this = this;
                return _asyncToGenerator(function() {
                    return __generator(this, function(_state) {
                        return [
                            2,
                            _this.options
                        ];
                    });
                })();
            }
        },
        {
            key: "getProvider",
            value: function getProvider() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var options;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.provider === null)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.getOptions()
                                ];
                            case 1:
                                options = _state.sent();
                                return [
                                    4,
                                    ECDSAProvider.init({
                                        bundlerProvider: options.bundlerProvider,
                                        projectId: options.projectId,
                                        owner: options.owner,
                                        opts: {
                                            providerConfig: {
                                                rpcUrl: options.rpcUrl
                                            },
                                            accountConfig: {
                                                index: options.index
                                            },
                                            paymasterConfig: {
                                                paymasterProvider: options.paymasterProvider,
                                                onlySendSponsoredTransaction: options.onlySendSponsoredTransaction,
                                                policy: options.gasToken ? "TOKEN_PAYMASTER" : "VERIFYING_PAYMASTER",
                                                gasToken: options.gasToken
                                            }
                                        }
                                    })
                                ];
                            case 2:
                                _this.provider = _state.sent();
                                _this.provider.on = function() {};
                                _this.provider.removeListener = function() {};
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _this.provider
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isAuthorized",
            value: function isAuthorized() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var _getConfig_storage, account, e;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.getOptions()
                                ];
                            case 1:
                                if (!_state.sent().shimDisconnect || !((_getConfig_storage = getConfig().storage) === null || _getConfig_storage === void 0 ? void 0 : _getConfig_storage.getItem(_this.shimDisconnectKey))) return [
                                    2,
                                    false
                                ];
                                return [
                                    4,
                                    _this.getAccount()
                                ];
                            case 2:
                                account = _state.sent();
                                return [
                                    2,
                                    !!account
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getChainId",
            value: function getChainId() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var chainId;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getChainIdFromProjectId(_this.options.projectId)
                                ];
                            case 1:
                                chainId = _state.sent();
                                if (!chainId) return [
                                    2,
                                    _this.chains[0].id
                                ];
                                return [
                                    2,
                                    chainId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getChain",
            value: function getChain() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var chainId, chain;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getChainId()
                                ];
                            case 1:
                                chainId = _state.sent();
                                chain = _this.chains.find(function(chain2) {
                                    return chain2.id === chainId;
                                });
                                if (!chain) throw new Error("Please add ".concat(chainId, " to chains"));
                                return [
                                    2,
                                    chain
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getWalletClient",
            value: function getWalletClient() {
                var chainId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).chainId;
                var _this = this;
                return _asyncToGenerator(function() {
                    var provider, _tmp;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.walletClient) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (!provider) throw new Error("provider is required");
                                _tmp = {};
                                return [
                                    4,
                                    _this.getAccount()
                                ];
                            case 2:
                                _tmp.account = _state.sent();
                                return [
                                    4,
                                    _this.getChain()
                                ];
                            case 3:
                                _this.walletClient = createWalletClient.apply(void 0, [
                                    (_tmp.chain = _state.sent(), _tmp.transport = custom(provider), _tmp)
                                ]);
                                _this.walletClient.sendUserOperation = provider.sendUserOperation.bind(provider);
                                _this.walletClient.waitForUserOperationTransaction = provider.waitForUserOperationTransaction.bind(provider);
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    _this.walletClient
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAccount",
            value: function getAccount() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var provider;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getProvider()
                                ];
                            case 1:
                                provider = _state.sent();
                                if (!provider) throw new Error("provider is required");
                                return [
                                    4,
                                    provider.getAddress()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isChainUnsupported",
            value: function isChainUnsupported(chainId) {
                return !this.getProjectIdFromChainId(chainId);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var _getConfig_storage, options;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getOptions()
                                ];
                            case 1:
                                options = _state.sent();
                                _this.provider = null;
                                if (!options.disconnect) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    options.disconnect()
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    4,
                                    _this.getOptions()
                                ];
                            case 4:
                                if (_state.sent().shimDisconnect) (_getConfig_storage = getConfig().storage) === null || _getConfig_storage === void 0 ? void 0 : _getConfig_storage.removeItem(_this.shimDisconnectKey);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "switchChain",
            value: function switchChain(chainId) {
                var _this = this;
                return _asyncToGenerator(function() {
                    var options, projectId, chain, error;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.getOptions()
                                ];
                            case 1:
                                options = _state.sent();
                                return [
                                    4,
                                    _this.getProjectIdFromChainId(chainId)
                                ];
                            case 2:
                                projectId = _state.sent();
                                if (!projectId) throw Error("Not Project provided associated with chain: ".concat(chainId));
                                options.projectId = projectId;
                                return [
                                    4,
                                    _this.getChain()
                                ];
                            case 3:
                                chain = _state.sent();
                                _this.provider = null;
                                _this.walletClient = null;
                                return [
                                    4,
                                    _this.getProvider()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this.getWalletClient()
                                ];
                            case 5:
                                _state.sent();
                                _this.emit("change", {
                                    chain: {
                                        id: chainId,
                                        unsupported: false
                                    }
                                });
                                return [
                                    2,
                                    chain
                                ];
                            case 6:
                                error = _state.sent();
                                throw error;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onChainChanged",
            value: function onChainChanged(chainId) {
                var id = normalizeChainId(chainId);
                var unsupported = this.isChainUnsupported(id);
                this.emit("change", {
                    chain: {
                        id: id,
                        unsupported: unsupported
                    }
                });
            }
        },
        {
            key: "onAccountsChanged",
            value: function onAccountsChanged(accounts) {
                if (accounts.length === 0) this.emit("disconnect");
                else this.emit("change", {
                    account: accounts[0]
                });
            }
        },
        {
            key: "onDisconnect",
            value: function onDisconnect() {
                var _this = this;
                this.emit("disconnect");
                this.getOptions().then(function(options) {
                    if (options.disconnect) {
                        var _getConfig_storage;
                        options.disconnect();
                        if (options.shimDisconnect) (_getConfig_storage = getConfig().storage) === null || _getConfig_storage === void 0 ? void 0 : _getConfig_storage.removeItem(_this.shimDisconnectKey);
                        _this.provider = null;
                    }
                });
            }
        }
    ]);
    return ZeroDevConnector;
}(Connector);
// src/connectors/AbstractWeb3AuthWalletConnector.tsx
import { ZeroDevWeb3Auth } from "@zerodev/web3auth";
import { getConfig as getConfig2 } from "@wagmi/core";
import { connect } from "wagmi/actions";
import { createWalletClient as createWalletClient2, custom as custom2 } from "viem";
var AbstractWeb3AuthWalletConnector = /*#__PURE__*/ function(ZeroDevConnector) {
    "use strict";
    _inherits(AbstractWeb3AuthWalletConnector, ZeroDevConnector);
    var _super = _createSuper(AbstractWeb3AuthWalletConnector);
    function AbstractWeb3AuthWalletConnector(param) {
        var _param_chains = param.chains, chains = _param_chains === void 0 ? [] : _param_chains, options = param.options;
        _classCallCheck(this, AbstractWeb3AuthWalletConnector);
        var _this;
        _this = _super.call(this, {
            chains: chains,
            options: options
        });
        _this.getChainId().then(function(chainId) {
            if (_this.options.projectIds) {
                var _getConfig2_storage, _getConfig2_storage1;
                var web3AuthInitOptions = {};
                _this.web3Auth = new ZeroDevWeb3Auth(_this.options.projectIds, chainId, {
                    adapterSettings: options.adapterSettings,
                    web3authOptions: options.web3authOptions
                });
                if (((_getConfig2_storage = getConfig2().storage) === null || _getConfig2_storage === void 0 ? void 0 : _getConfig2_storage.getItem("".concat(_this.loginProvider, "-connecting"))) || options.shimDisconnect && ((_getConfig2_storage1 = getConfig2().storage) === null || _getConfig2_storage1 === void 0 ? void 0 : _getConfig2_storage1.getItem(_this.shimDisconnectKey))) {
                    var _this1 = _assertThisInitialized(_this);
                    web3AuthInitOptions["onConnect"] = function() {
                        var _ref = _asyncToGenerator(function(userInfo) {
                            var _getConfig2_storage;
                            return __generator(this, function(_state) {
                                if (_this1.loginProvider === userInfo.typeOfLogin) {
                                    _this1.owner = _this1.web3Auth.provider;
                                    connect({
                                        chainId: chainId,
                                        connector: _this1
                                    });
                                }
                                (_getConfig2_storage = getConfig2().storage) === null || _getConfig2_storage === void 0 ? void 0 : _getConfig2_storage.setItem("".concat(_this1.loginProvider, "-connecting"), false);
                                return [
                                    2
                                ];
                            });
                        });
                        return function(userInfo) {
                            return _ref.apply(this, arguments);
                        };
                    }();
                }
                _this.web3Auth.init(web3AuthInitOptions, _this.loginProvider);
            }
        });
        return _this;
    }
    _createClass(AbstractWeb3AuthWalletConnector, [
        {
            key: "isAuthorized",
            value: function isAuthorized() {
                var _this = this;
                var _this1 = this, _superprop_get_isAuthorized = function() {
                    return _get(_getPrototypeOf(AbstractWeb3AuthWalletConnector.prototype), "isAuthorized", _this);
                };
                return _asyncToGenerator(function() {
                    var _this_web3Auth, _getConfig2_storage, provider, _tmp, _this_web3Auth1;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    2,
                                    false
                                ];
                            case 1:
                                _tmp = _state.sent().shimDisconnect || ((_getConfig2_storage = getConfig2().storage) === null || _getConfig2_storage === void 0 ? void 0 : _getConfig2_storage.getItem(_this1.shimDisconnectKey));
                                _state.label = 2;
                            case 2:
                                if (!_tmp) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (_this_web3Auth1 = _this1.web3Auth) === null || _this_web3Auth1 === void 0 ? void 0 : _this_web3Auth1.connect(_this1.loginProvider)
                                ];
                            case 3:
                                provider = _state.sent();
                                _state.label = 4;
                            case 4:
                                if (provider) {
                                    _this1.owner = provider;
                                }
                                return [
                                    2,
                                    _superprop_get_isAuthorized().call(_this1)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "connect",
            value: function connect(param) {
                var chainId = param.chainId;
                var _this = this;
                var _this1 = this, _superprop_get_connect = function() {
                    return _get(_getPrototypeOf(AbstractWeb3AuthWalletConnector.prototype), "connect", _this);
                };
                return _asyncToGenerator(function() {
                    var _this_web3Auth, _this_web3Auth1, _ref, _this_web3Auth2, provider, _tmp, _this_web3Auth3, _getConfig2_storage, _this_web3Auth4, walletClient, _tmp1, address;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this1.owner) return [
                                    3,
                                    9
                                ];
                                provider = (_this_web3Auth = _this1.web3Auth) === null || _this_web3Auth === void 0 ? void 0 : _this_web3Auth.provider;
                                _tmp = ((_this_web3Auth1 = _this1.web3Auth) === null || _this_web3Auth1 === void 0 ? void 0 : _this_web3Auth1.status) === "connected";
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (_this_web3Auth2 = _this1.web3Auth) === null || _this_web3Auth2 === void 0 ? void 0 : _this_web3Auth2.getUserInfo()
                                ];
                            case 1:
                                _tmp = ((_ref = _state.sent()) === null || _ref === void 0 ? void 0 : _ref.typeOfLogin) !== _this1.loginProvider;
                                _state.label = 2;
                            case 2:
                                if (!_tmp) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (_this_web3Auth3 = _this1.web3Auth) === null || _this_web3Auth3 === void 0 ? void 0 : _this_web3Auth3.logout()
                                ];
                            case 3:
                                _state.sent();
                                provider = null;
                                _state.label = 4;
                            case 4:
                                if (!!provider) return [
                                    3,
                                    6
                                ];
                                (_getConfig2_storage = getConfig2().storage) === null || _getConfig2_storage === void 0 ? void 0 : _getConfig2_storage.setItem("".concat(_this1.loginProvider, "-connecting"), true);
                                return [
                                    4,
                                    (_this_web3Auth4 = _this1.web3Auth) === null || _this_web3Auth4 === void 0 ? void 0 : _this_web3Auth4.connect(_this1.loginProvider)
                                ];
                            case 5:
                                provider = _state.sent();
                                setTimeout(function() {
                                    var _getConfig2_storage;
                                    (_getConfig2_storage = getConfig2().storage) === null || _getConfig2_storage === void 0 ? void 0 : _getConfig2_storage.setItem("".concat(_this1.loginProvider, "-connecting"), false);
                                }, 1e3);
                                _state.label = 6;
                            case 6:
                                _tmp1 = {};
                                return [
                                    4,
                                    _this1.getChain()
                                ];
                            case 7:
                                walletClient = createWalletClient2.apply(void 0, [
                                    (_tmp1.chain = _state.sent(), _tmp1.transport = custom2(provider), _tmp1)
                                ]);
                                return [
                                    4,
                                    walletClient.getAddresses()
                                ];
                            case 8:
                                address = _state.sent()[0];
                                _this1.owner = {
                                    getAddress: /*#__PURE__*/ _asyncToGenerator(function() {
                                        return __generator(this, function(_state) {
                                            return [
                                                2,
                                                address
                                            ];
                                        });
                                    }),
                                    signMessage: function() {
                                        var _ref = _asyncToGenerator(function(message) {
                                            return __generator(this, function(_state) {
                                                return [
                                                    2,
                                                    walletClient.signMessage({
                                                        account: address,
                                                        message: typeof message === "string" ? message : {
                                                            raw: message
                                                        }
                                                    })
                                                ];
                                            });
                                        });
                                        return function(message) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    signTypedData: function() {
                                        var _ref = _asyncToGenerator(function(params) {
                                            return __generator(this, function(_state) {
                                                return [
                                                    2,
                                                    walletClient.signTypedData(_objectSpreadProps(_objectSpread({}, params), {
                                                        account: address
                                                    }))
                                                ];
                                            });
                                        });
                                        return function(params) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()
                                };
                                _state.label = 9;
                            case 9:
                                return [
                                    4,
                                    _superprop_get_connect().call(_this1, {
                                        chainId: chainId
                                    })
                                ];
                            case 10:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var _this = this;
                var _this1 = this, _superprop_get_getOptions = function() {
                    return _get(_getPrototypeOf(AbstractWeb3AuthWalletConnector.prototype), "getOptions", _this);
                };
                return _asyncToGenerator(function() {
                    var options;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this1.owner) {
                                    _this1.options.owner = _this1.owner;
                                }
                                return [
                                    4,
                                    _superprop_get_getOptions().call(_this1)
                                ];
                            case 1:
                                options = _state.sent();
                                options.disconnect = /*#__PURE__*/ _asyncToGenerator(function() {
                                    var _this_web3Auth;
                                    return __generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    (_this_web3Auth = _this1.web3Auth) === null || _this_web3Auth === void 0 ? void 0 : _this_web3Auth.logout()
                                                ];
                                            case 1:
                                                _state.sent();
                                                _this1.owner = void 0;
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return [
                                    2,
                                    options
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AbstractWeb3AuthWalletConnector;
}(ZeroDevConnector);
// src/connectors/GoogleSocialWalletConnector.tsx
var GoogleSocialWalletConnector = /*#__PURE__*/ function(AbstractWeb3AuthWalletConnector) {
    "use strict";
    _inherits(GoogleSocialWalletConnector, AbstractWeb3AuthWalletConnector);
    var _super = _createSuper(GoogleSocialWalletConnector);
    function GoogleSocialWalletConnector() {
        _classCallCheck(this, GoogleSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "google";
        _this.name = "Google";
        _this.loginProvider = "google";
        return _this;
    }
    return GoogleSocialWalletConnector;
}(AbstractWeb3AuthWalletConnector);
// src/integrations/rainbowkit/wallets/googleWallet.tsx
function googleWallet(param) {
    var chains = param.chains, options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/2048px-Google_%22G%22_Logo.svg.png",
        id: "openlogin_google",
        name: "Google",
        createConnector: function() {
            return {
                connector: new GoogleSocialWalletConnector({
                    chains: chains,
                    options: options
                })
            };
        }
    };
}
// src/connectors/TwitterSocialWalletConnector.tsx
var TwitterSocialWalletConnector = /*#__PURE__*/ function(AbstractWeb3AuthWalletConnector) {
    "use strict";
    _inherits(TwitterSocialWalletConnector, AbstractWeb3AuthWalletConnector);
    var _super = _createSuper(TwitterSocialWalletConnector);
    function TwitterSocialWalletConnector() {
        _classCallCheck(this, TwitterSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "twitter";
        _this.name = "Twitter";
        _this.loginProvider = "twitter";
        return _this;
    }
    return TwitterSocialWalletConnector;
}(AbstractWeb3AuthWalletConnector);
// src/integrations/rainbowkit/wallets/twitterWallet.tsx
function twitterWallet(param) {
    var chains = param.chains, options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://cdn3.iconfinder.com/data/icons/inficons/512/twitter.png",
        id: "openlogin_twitter",
        name: "Twitter",
        createConnector: function createConnector() {
            return {
                connector: new TwitterSocialWalletConnector({
                    chains: chains,
                    options: options
                })
            };
        }
    };
}
// src/connectors/TwitchSocialWalletConnector.tsx
var TwitchSocialWalletConnector = /*#__PURE__*/ function(AbstractWeb3AuthWalletConnector) {
    "use strict";
    _inherits(TwitchSocialWalletConnector, AbstractWeb3AuthWalletConnector);
    var _super = _createSuper(TwitchSocialWalletConnector);
    function TwitchSocialWalletConnector() {
        _classCallCheck(this, TwitchSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "twitch";
        _this.name = "Twitch";
        _this.loginProvider = "twitch";
        return _this;
    }
    return TwitchSocialWalletConnector;
}(AbstractWeb3AuthWalletConnector);
// src/integrations/rainbowkit/wallets/twitchWallet.tsx
function twitchWallet(param) {
    var chains = param.chains, options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://cdn4.iconfinder.com/data/icons/logos-brands-7/512/twitch-1024.png",
        id: "openlogin_twitch",
        name: "Twitch",
        createConnector: function createConnector() {
            return {
                connector: new TwitchSocialWalletConnector({
                    chains: chains,
                    options: options
                })
            };
        }
    };
}
// src/connectors/FacebookSocialWalletConnector.tsx
var FacebookSocialWalletConnector = /*#__PURE__*/ function(AbstractWeb3AuthWalletConnector) {
    "use strict";
    _inherits(FacebookSocialWalletConnector, AbstractWeb3AuthWalletConnector);
    var _super = _createSuper(FacebookSocialWalletConnector);
    function FacebookSocialWalletConnector() {
        _classCallCheck(this, FacebookSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "facebook";
        _this.name = "Facebook";
        _this.loginProvider = "facebook";
        return _this;
    }
    return FacebookSocialWalletConnector;
}(AbstractWeb3AuthWalletConnector);
// src/integrations/rainbowkit/wallets/facebookWallet.tsx
function facebookWallet(param) {
    var chains = param.chains, options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://cdn2.iconfinder.com/data/icons/social-icons-33/128/Facebook-512.png",
        id: "openlogin_facebook",
        name: "Facebook",
        createConnector: function createConnector() {
            return {
                connector: new FacebookSocialWalletConnector({
                    chains: chains,
                    options: options
                })
            };
        }
    };
}
// src/connectors/GithubSocialWalletConnector.tsx
var GithubSocialWalletConnector = /*#__PURE__*/ function(AbstractWeb3AuthWalletConnector) {
    "use strict";
    _inherits(GithubSocialWalletConnector, AbstractWeb3AuthWalletConnector);
    var _super = _createSuper(GithubSocialWalletConnector);
    function GithubSocialWalletConnector() {
        _classCallCheck(this, GithubSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "github";
        _this.name = "Github";
        _this.loginProvider = "github";
        return _this;
    }
    return GithubSocialWalletConnector;
}(AbstractWeb3AuthWalletConnector);
// src/integrations/rainbowkit/wallets/githubWallet.tsx
function githubWallet(param) {
    var chains = param.chains, options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/142_Github_logo_logos-512.png",
        id: "openlogin_github",
        name: "Github",
        createConnector: function createConnector() {
            return {
                connector: new GithubSocialWalletConnector({
                    chains: chains,
                    options: options
                })
            };
        }
    };
}
// src/connectors/DiscordSocialWalletConnector.tsx
var DiscordSocialWalletConnector = /*#__PURE__*/ function(AbstractWeb3AuthWalletConnector) {
    "use strict";
    _inherits(DiscordSocialWalletConnector, AbstractWeb3AuthWalletConnector);
    var _super = _createSuper(DiscordSocialWalletConnector);
    function DiscordSocialWalletConnector() {
        _classCallCheck(this, DiscordSocialWalletConnector);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.id = "discord";
        _this.name = "Discord";
        _this.loginProvider = "discord";
        return _this;
    }
    return DiscordSocialWalletConnector;
}(AbstractWeb3AuthWalletConnector);
// src/integrations/rainbowkit/wallets/discordWallet.tsx
function discordWallet(param) {
    var chains = param.chains, options = param.options;
    return {
        iconBackground: "#fff",
        iconUrl: "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/91_Discord_logo_logos-512.png",
        id: "openlogin_discord",
        name: "Discord",
        createConnector: function createConnector() {
            return {
                connector: new DiscordSocialWalletConnector({
                    chains: chains,
                    options: options
                })
            };
        }
    };
}
// src/utilities/enhanceConnectorWithAA.tsx
import { ECDSAProvider as ECDSAProvider2, getRPCProviderOwner } from "@zerodev/sdk";
// src/services/ZeroDevApiService.tsx
var _ZeroDevApiService = /*#__PURE__*/ function() {
    "use strict";
    function _ZeroDevApiService1() {
        _classCallCheck(this, _ZeroDevApiService1);
    }
    _createClass(_ZeroDevApiService1, null, [
        {
            key: "getProjectConfiguration",
            value: function getProjectConfiguration(projectId) {
                return _asyncToGenerator(function() {
                    var resp;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetch("".concat(_ZeroDevApiService.baseUrl, "/v1/projects/").concat(projectId), {
                                        method: "GET",
                                        headers: {
                                            "Content-Type": "application/json"
                                        }
                                    })
                                ];
                            case 1:
                                resp = _state.sent();
                                return [
                                    4,
                                    resp.json()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return _ZeroDevApiService1;
}();
var ZeroDevApiService = _ZeroDevApiService;
var _process_env_REACT_APP_ZERODEV_BACKEND_URL1;
ZeroDevApiService.baseUrl = (_process_env_REACT_APP_ZERODEV_BACKEND_URL1 = process.env.REACT_APP_ZERODEV_BACKEND_URL) !== null && _process_env_REACT_APP_ZERODEV_BACKEND_URL1 !== void 0 ? _process_env_REACT_APP_ZERODEV_BACKEND_URL1 : "https://backend-vikp.onrender.com";
// src/utilities/enhanceConnectorWithAA.tsx
import { createWalletClient as createWalletClient3, custom as custom3 } from "viem";
var enhanceConnectorWithAA = function(connector, params) {
    var provider = null;
    var walletClient = null;
    var _wallets;
    var enhancedConnector = new Proxy(connector, {
        set: function set(target, prop, value, receiver) {
            if (prop === "_wallets") {
                return _wallets = value;
            }
            return Reflect.set(target, prop, value, receiver);
        },
        get: function get(target, prop, receiver) {
            if (prop === "_wallets") return _wallets;
            if (prop === "switchChain") return void 0;
            var value = target[prop];
            if (prop === "id") value += "-zerodev";
            if (_instanceof(value, Function)) {
                return /*#__PURE__*/ _asyncToGenerator(function() {
                    var _len, args, _key, source, _tmp, _tmp1, response, chainId, chain, chainId1, chain1, _tmp2;
                    var _arguments = arguments;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                    args[_key] = _arguments[_key];
                                }
                                return [
                                    4,
                                    value.apply(target, args)
                                ];
                            case 1:
                                source = _state.sent();
                                switch(prop){
                                    case "connect":
                                        return [
                                            3,
                                            2
                                        ];
                                    case "getChainId":
                                        return [
                                            3,
                                            4
                                        ];
                                    case "getProvider":
                                        return [
                                            3,
                                            8
                                        ];
                                    case "getWalletClient":
                                        return [
                                            3,
                                            12
                                        ];
                                    case "getAccount":
                                        return [
                                            3,
                                            16
                                        ];
                                    case "disconnect":
                                        return [
                                            3,
                                            19
                                        ];
                                }
                                return [
                                    3,
                                    20
                                ];
                            case 2:
                                _tmp = [
                                    _objectSpread({}, source)
                                ];
                                _tmp1 = {};
                                return [
                                    4,
                                    receiver.getAccount()
                                ];
                            case 3:
                                return [
                                    2,
                                    _objectSpreadProps.apply(void 0, _tmp.concat([
                                        (_tmp1.account = _state.sent(), _tmp1)
                                    ]))
                                ];
                            case 4:
                                if (!(provider === null)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    ZeroDevApiService.getProjectConfiguration(params.projectId)
                                ];
                            case 5:
                                response = _state.sent();
                                return [
                                    2,
                                    response["chainId"]
                                ];
                            case 6:
                                return [
                                    4,
                                    receiver.getProvider()
                                ];
                            case 7:
                                return [
                                    2,
                                    _state.sent().chainId
                                ];
                            case 8:
                                if (!(provider === null)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    receiver.getChainId()
                                ];
                            case 9:
                                chainId = _state.sent();
                                chain = connector.chains.find(function(c) {
                                    return c.id === chainId;
                                });
                                if (!chain) throw new Error("missing chain");
                                return [
                                    4,
                                    ECDSAProvider2.init({
                                        projectId: params.projectId,
                                        owner: getRPCProviderOwner(source),
                                        opts: {
                                            paymasterConfig: {
                                                policy: "VERIFYING_PAYMASTER"
                                            }
                                        }
                                    })
                                ];
                            case 10:
                                provider = _state.sent();
                                _state.label = 11;
                            case 11:
                                return [
                                    2,
                                    provider
                                ];
                            case 12:
                                if (!!walletClient) return [
                                    3,
                                    15
                                ];
                                if (!provider) throw new Error("provider is required");
                                return [
                                    4,
                                    receiver.getChainId()
                                ];
                            case 13:
                                chainId1 = _state.sent();
                                chain1 = receiver.chains.find(function(chain2) {
                                    return chain2.id === chainId1;
                                });
                                _tmp2 = {};
                                return [
                                    4,
                                    receiver.getAccount()
                                ];
                            case 14:
                                walletClient = createWalletClient3.apply(void 0, [
                                    (_tmp2.account = _state.sent(), _tmp2.chain = chain1, _tmp2.transport = custom3(provider), _tmp2)
                                ]);
                                walletClient.sendUserOperation = provider.sendUserOperation.bind(provider);
                                walletClient.waitForUserOperationTransaction = provider.waitForUserOperationTransaction.bind(provider);
                                _state.label = 15;
                            case 15:
                                return [
                                    2,
                                    walletClient
                                ];
                            case 16:
                                return [
                                    4,
                                    receiver.getProvider()
                                ];
                            case 17:
                                return [
                                    4,
                                    _state.sent().getAddress()
                                ];
                            case 18:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 19:
                                provider = null;
                                _state.label = 20;
                            case 20:
                                return [
                                    2,
                                    source
                                ];
                            case 21:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
            return value;
        }
    });
    var onAccountsChanged = enhancedConnector["onAccountsChanged"];
    enhancedConnector["onAccountsChanged"] = function() {
        provider = null;
        enhancedConnector.getAccount().then(function(account) {
            return onAccountsChanged([
                account
            ]);
        });
    };
    enhancedConnector["onChainChanged"] = function() {};
    var onDisconnect = enhancedConnector["onDisconnect"];
    enhancedConnector["onDisconnect"] = function(error) {
        provider = null;
        onDisconnect(error);
    };
    return enhancedConnector;
};
// src/integrations/rainbowkit/enhanceWalletWithAAConnector.tsx
var enhanceWalletWithAAConnector = function(wallet, params) {
    return new Proxy(wallet, {
        get: function get(target, prop, receiver) {
            var source = Reflect.get(target, prop, receiver);
            if (prop === "createConnector") {
                return function() {
                    var result = source();
                    return _objectSpreadProps(_objectSpread({}, result), {
                        connector: enhanceConnectorWithAA(result["connector"], params)
                    });
                };
            }
            return source;
        }
    });
};
export { discordWallet, enhanceWalletWithAAConnector, facebookWallet, githubWallet, googleWallet, twitchWallet, twitterWallet };
